export default __webpack_public_path__ + "static/get-quote-banner-bg-ce98d86b1c35d163cec4e4f61d437140.png";